import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import ApplyForRemoteRequest from "./index";

const ApplyForRemoteRequestFormModal = ({
  title,
  className,
  id,
  open,
  handleClose,
  data,
  isEmployee,
  ...rest
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason == "backdropClick" && reason !== "escapeKeyDown") {
          handleClose(id);
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="ta-modal applyforremoterequest-modal"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" className="modal_header">
        <span className={className}> {title} </span>
        <div className="close_button">
          <CloseIcon onClick={() => handleClose(id)} />
        </div>
      </DialogTitle>
      <DialogContent>
        <ApplyForRemoteRequest
          handleClose={handleClose}
          id={id}
          remoteRequestDetails={false}
          updateMyRemoteRequest={false}
          disabled={false}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ApplyForRemoteRequestFormModal;